var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 98.52 17.38"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M98.52 0C64.89 0 31.55 5.89 0 17.38.35 11.6.52 5.8.52 0h98z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }